import store from '@/store/'

// eslint-disable-next-line no-unused-vars
export default function whitelabelApp({ from, next, router, to }) {
  // PD-4862 — "has at least one accessible whitelabel", from the access list. The old
  // check read `user/apps'].id`, which only knew about a single resolved app.
  if (!store.getters['user/has_whitelabel_app']) {
    return router.push({ name: 'dashboard' })
  }

  return next()
}
